angular.module('capability-ng-global').run(function($rootScope: ng.IRootScopeService, $state: ng.ui.IStateService) {
  const IS_MODAL = /modal/i;

  $rootScope.$on('$stateChangeStart', function(evt, toState, toParams, fromState) {
    if (fromState.name === '' && toState.name.match(IS_MODAL) !== null) {
      const defaultState = sessionStorage.getItem('previousState') || 'my.transfer.credits.major';

      evt.preventDefault();
      $state
        .go(defaultState, undefined, {
          location: false
        })
        .then(function() {
          $state.go(toState, toParams);
        });
    } else {
      sessionStorage.setItem('previousState', fromState.name);
    }
  });
});



// WEBPACK FOOTER //
// ./app/lib/global/configuration/modal_recovery.ts